import { Helmet } from "react-helmet-async";
import React, { useContext, useEffect } from "react";
import { MetadataContext } from "../Contexts/MetadataContext";
import { useLocation } from "react-router-dom";
import { getPageTypeId } from "../Utils/pageMap";

export default function Meta() {
  const { metadata, loading } = useContext(MetadataContext);
  const location = useLocation();

  const pageTypeId = getPageTypeId(location.pathname);

  useEffect(() => {
    console.log("Meta component mounted or updated", metadata, pageTypeId);
  }, [metadata, pageTypeId]);

  if (loading) return null;

  const metaArray = metadata ? Object.values(metadata) : [];

  const meta =  metaArray.find(m => m.Page === pageTypeId) || {
    Title: "Play MegaStore",
    Description: "Shop the latest laptops, smartphones, electronics, and accessories at unbeatable prices. Fast delivery, secure checkout, and top brands — all in one place at Play MegaStore.",
    Keywords: "laptops, smartphones, electronics, accessories, Play MegaStore, buy laptop online, buy phone online, gaming laptops, mobile accessories",
    Url: window.location.href,
    Type: "website",
    Image: "",
    TwitterCard: "summary_large_image",
  };

  return (
    <Helmet>
      <title>{meta.Title}</title>
      <meta name="title" content={meta.Title} />
      <meta name="description" content={meta.Description} />
      <meta name="keywords" content={meta.Keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={meta.Title} />
      <meta property="og:description" content={meta.Description} />
      <meta property="og:type" content={meta.Type} />
      <meta property="og:url" content={meta.Url} />
      <meta property="og:image" content={meta.Image} />

      {/* Twitter Card */}
      <meta name="twitter:card" content={meta.TwitterCard} />
      <meta name="twitter:title" content={meta.Title} />
      <meta name="twitter:description" content={meta.Description} />
      <meta name="twitter:image" content={meta.Image} />
    </Helmet>
  );
}
